export const LOAD_CURRENT_USER = 'user/LOAD_CURRENT_USER';
export const UPDATE_CURRENT_USER = 'user/UPDATE_CURRENT_USER';
export const SET_USER_LANGUAGE = 'user/SET_USER_LANGUAGE';
export const USER_LOGOUT = 'user/USER_LOGOUT';
